import { logDebug } from './logger';

/**
 * Utility functions for device detection
 */

/**
 * Detect if the current device is a mobile device
 * Based on userAgent string
 * 
 * @returns {boolean} true if mobile device, false if desktop
 */
export const isMobileDevice = () => {
  if (typeof window === 'undefined' || !navigator) {
    logDebug('[DeviceDetection] Window or navigator not available');
    return false;
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
  const uaData = navigator.userAgentData || null;
  const uaDataMobile = uaData && typeof uaData.mobile === 'boolean' ? uaData.mobile : null;
  const maxTouchPoints = Number(navigator.maxTouchPoints || 0);
  const screenWidth = window.screen?.width || window.innerWidth || 0;

  const mobilePattern = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini|Mobile|CriOS|Fennec|Windows Phone|Kindle|Silk|PlayBook|BB10|Tablet/i;
  const desktopPattern = /Windows NT|Macintosh|X11|Linux x86_64|CrOS/i;

  // Chromium exposes UA-CH mobile signal; trust this first because DevTools UA spoof usually cannot fake it.
  if (uaDataMobile === true) {
    logDebug('[DeviceDetection] UAData mobile=true');
    return true;
  }
  if (uaDataMobile === false) {
    logDebug('[DeviceDetection] UAData mobile=false');
    return false;
  }

  const hasMobileUA = mobilePattern.test(userAgent);
  const hasDesktopUA = desktopPattern.test(userAgent);
  const looksTouchDevice = maxTouchPoints >= 2 && screenWidth > 0 && screenWidth <= 1024;

  const result = (hasMobileUA && !hasDesktopUA) || (looksTouchDevice && !hasDesktopUA);

  logDebug('[DeviceDetection] UserAgent:', userAgent);
  logDebug('[DeviceDetection] hasMobileUA:', hasMobileUA);
  logDebug('[DeviceDetection] hasDesktopUA:', hasDesktopUA);
  logDebug('[DeviceDetection] maxTouchPoints:', maxTouchPoints);
  logDebug('[DeviceDetection] screenWidth:', screenWidth);
  logDebug('[DeviceDetection] Final result:', result);

  return result;
};

/**
 * Get device type as string
 * @returns {string} 'mobile' or 'desktop'
 */
export const getDeviceType = () => {
  return isMobileDevice() ? 'mobile' : 'desktop';
};
